import React from "react";
import { IonItem } from "@ionic/react";
import { IUserProgramCertificate, ProgramCertificate } from "@interfaces/Interfaces";
import * as StringUtils from "@utils/stringUtils";
import { Button_Disclosure_Right_Grey } from "@assets/images";
import * as ProgramUtils from "@utils/programUtils";

type Props = {
  certificate: ProgramCertificate;
  buttonPressed: () => void;
  programCertificates: IUserProgramCertificate[];
  role?: string;
  programID: string;
  defaultButtonText?: string;
};

const ProgramCertificateButton: React.FC<Props> = (props) => {
  const userCertificate = props.programCertificates.find(
    (certificate) => certificate.programData.certificateID === props.certificate.ID
  );

  return (
    <IonItem
      button
      className="part program-skill-button !flex !w-full flex-col !pl-0 !shadow-unset"
      detail={false}
      key={props.certificate.ID}
      onClick={props.buttonPressed}
    >
      <div className="w-full pl-0">
        <div className="flex flex-row items-center justify-between py-[8px] shadow-program-skill shadow-grey-30">
          <div className="flex max-w-half flex-col">
            <div className="acc-underline text-acc-15px leading-[1.33] tracking-[-0.3px] text-grey-90">
              {props.certificate.Name}
            </div>
          </div>
          <div className="flex flex-row items-center">
            {userCertificate?.verificationStatus?.status === "Pending" ? (
              <div className="h-[20px] shrink-0 rounded-[10px] bg-[#FEEBC8] px-[8px] py-0 text-right text-[13px] font-semibold leading-[1.54] tracking-[-0.05px] text-[#9C4221]">
                {"Awaiting verification"}
              </div>
            ) : (
              <div
                className={
                  ProgramUtils.isSwastOrNwasEprrProgram(props.programID)
                    ? StringUtils.getSwastNwasEprrCertificatePillContainerClassNoExpiry({
                        certificate: userCertificate,
                        duration: props.certificate.Duration,
                        canBeBlank: true,
                      })
                    : StringUtils.getCertificatePillContainerClassNoExpiry({
                        certificate: userCertificate,
                        duration: props.certificate.Duration,
                        canBeBlank: true,
                        programID: props.programID,
                      })
                }
              >
                {StringUtils.getCertificatePillStringNoExpiry(
                  userCertificate,
                  props.certificate.Duration,
                  true,
                  props.defaultButtonText
                )}
              </div>
            )}
            <img
              className="img-no-select size-6"
              src={Button_Disclosure_Right_Grey}
            />
          </div>
        </div>
      </div>
    </IonItem>
  );
};

export default ProgramCertificateButton;
